<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card-text>
        <h2 style="margin: 0% auto;"><b>Pemerintah</b></h2>
      </v-card-text>

      <v-card-text class="pa-0 margin-title">
        
        <v-card v-if="pemerintahID">
          <pemerintah-list></pemerintah-list>
        </v-card>

        <v-card v-else>
          <pemerintah-list-two></pemerintah-list-Two>
        </v-card>

      </v-card-text>

    </v-layout>
  </v-container>     
</template>

<script>
import { getUserById } from '@/api/user';

import VWidget from '@/components/VWidget';
import PemerintahList from '@/components/pemerintah/PemerintahList'
import PemerintahListTwo from '@/components/pemerintah/PemerintahListTwo'
import TambahkanPemerintah from '@/components/pemerintah/TambahkanPemerintah'
export default {
  components: {
    VWidget,
    PemerintahList,
    PemerintahListTwo,
    TambahkanPemerintah,
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
      status: false,
      pemerintahID: localStorage.pemerintahID
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'Pemerintah',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },
};
</script>